export enum TaskType {
    MT_ACTIE = 'MT actie',
    MT = 'MT',
    Proc = 'Proc',
    Proces = 'Proces',
    Deliv = 'Deliv',
    Deliverable = 'Deliverable',
}
